function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
import React, { Component } from "react";
import PropTypes from "prop-types";
import styled, { isStyledComponent } from "styled-components";
var MaterialInputWrapper = styled.div.withConfig({
  displayName: "MaterialInput__MaterialInputWrapper"
})(["display:inline-block;padding-top:", ";position:relative;"], function (_ref) {
  var titleSize = _ref.titleSize,
    units = _ref.units;
  return "".concat(titleSize).concat(units);
});
var MaterialLabel = styled.label.withConfig({
  displayName: "MaterialInput__MaterialLabel"
})(["pointer-events:none;transition:all 150ms linear;position:absolute;color:", ";", ":0;top:", ";font-size:", ";"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.disabled;
}, function (_ref3) {
  var align = _ref3.align;
  return align;
}, function (_ref4) {
  var moved = _ref4.moved,
    titleSize = _ref4.titleSize,
    spacing = _ref4.spacing,
    units = _ref4.units;
  return "".concat(moved ? 0 : titleSize + spacing).concat(units);
}, function (_ref5) {
  var moved = _ref5.moved,
    titleSize = _ref5.titleSize,
    placeholderSize = _ref5.placeholderSize,
    units = _ref5.units;
  return "".concat(moved ? titleSize : placeholderSize).concat(units);
});
export var MaterialInput = /*#__PURE__*/
function (_Component) {
  _inherits(MaterialInput, _Component);
  function MaterialInput() {
    var _getPrototypeOf2;
    var _this;
    _classCallCheck(this, MaterialInput);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(MaterialInput)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      focused: false,
      labelMoved: _this.props.children.props.value !== ""
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleLabelMove", function (shouldFocus, originalFunction) {
      return function (e) {
        originalFunction && originalFunction(e);
        _this.setState({
          focused: shouldFocus,
          labelMoved: shouldFocus || e.target.value !== ""
        });
      };
    });
    return _this;
  }
  _createClass(MaterialInput, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;
      if (prevProps.children.props.value === "" !== (this.props.children.props.value === "")) {
        this.setState(function (state) {
          return {
            labelMoved: state.focused || _this2.props.children.props.value !== ""
          };
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var labelMoved = this.state.labelMoved;
      var _this$props = this.props,
        children = _this$props.children,
        label = _this$props.label,
        titleSize = _this$props.titleSize,
        placeholderSize = _this$props.placeholderSize,
        spacing = _this$props.spacing,
        align = _this$props.align,
        className = _this$props.className,
        units = _this$props.units;
      return React.createElement(MaterialInputWrapper, {
        titleSize: titleSize,
        className: className,
        units: units
      }, React.createElement(MaterialLabel, {
        align: align,
        moved: labelMoved,
        titleSize: titleSize,
        spacing: spacing,
        placeholderSize: placeholderSize,
        units: units
      }, label), React.cloneElement(children, {
        onFocus: this.handleLabelMove(true, children.props.onFocus),
        onBlur: this.handleLabelMove(false, children.props.onBlur)
      }));
    }
  }]);
  return MaterialInput;
}(Component);
_defineProperty(MaterialInput, "propTypes", {
  className: PropTypes.string,
  children: PropTypes.element.isRequired,
  label: PropTypes.string,
  titleSize: PropTypes.number,
  placeholderSize: PropTypes.number,
  spacing: PropTypes.number,
  align: PropTypes.oneOf(["left", "right"]),
  units: PropTypes.oneOf(["px", "em", "rem", "%", "cm", "ex", "in", "mm", "pc", "pt"])
});
_defineProperty(MaterialInput, "defaultProps", {
  className: "material-input",
  align: "left",
  titleSize: 14,
  placeholderSize: 24,
  spacing: 0,
  units: "px"
});
export default MaterialInput;